export const getScreenHeight = function () {
  return window.innerHeight
}
